import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/departmentCompany/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/departmentCompany/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/departmentCompany/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/departmentCompany/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/departmentCompany/update', params, options);

export const updateStart = (params, options) =>
  request.post('/api/v4ward/departmentCompany/updateStart', params, options);

export const updateOut = (params, options) =>
  request.post('/api/v4ward/departmentCompany/updateOut', params, options);

export const getDepartmentCompanyList = (params, options) =>
  request.get('/api/v4ward/departmentCompany/getDepartmentCompanyList', Object.assign({}, options));
